__webpack_require__.p = "https://test.app.avtar.ai/";